import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '96%',
      width: '100%',
      maxWidth: '100%',
      flex: 1,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(1),
    },
    separator: {
      borderLeft: `1px solid ${theme.palette.grey[200]}`,
    },
    label: {
      color: theme.palette.text.secondary,
      width: '100%',
      maxWidth: '100%',
    },
    sort: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),

      '&.desc': {
        transform: 'rotate(180deg)',
      },
    },
    actionsContainer: {
      marginLeft: theme.spacing(1),

      '& > * + *': {
        marginLeft: theme.spacing(1),
      },
    },
    actionButton: {
      minWidth: 'fit-content',
      color: theme.palette.text.secondary,
    },
    bold: {
      fontWeight: 'bold',
    },
    sorted: {
      color: theme.palette.primary.main,
    },
    skeleton: {
      height: theme.spacing(4),
    },
  }),
);
